(function() {
    var uiRouter = fpUtil.getNamespace('ui.router', fp),
        loc = window.location,
        routerLocation = (function() {
            var location = {};

            _.each(loc, function(value, key) {
                if(_.isFunction(value)) location[key] = $.proxy(value, loc);
                else location[key] = value;
            });

            $.extend(location, {
                origin: function () {
                    return loc.origin || loc.protocol + '//' + loc.host;
                },
                hash: function () {
                    return loc.hash;
                },
                href: function () {
                    //var origin = this.origin();
                    //return origin + S(loc.href).trimLeft(origin, true).clean('//', '/').s;
                    return loc.href;
                },
                pathname: function (includeSearchAndHash) {
                    if(includeSearchAndHash) {
                        return S(this.href()).trimLeft(this.origin(), true).s;
                    }

                    return S(loc.pathname).clean('//', '/').s;
                },
                port: function () {
                    return loc.port;
                },
                protocol: function () {
                    return loc.protocol;
                },
                search: function () {
                    return loc.search;
                },
                toString: function() {
                    return this.href();
                },
                //determine if the given url is the current page
                isCurrentPage: function(url, enableSearchParams) {
                    //fp.log('isCurrentPage');
                    url = S(url).trim();
                    if(!url.length) return true;

                    var origin = this.origin();

                    if(url.startsWith('/')) url = url.prepend(origin);

                    if(!url.startsWith('http', true)) return true;
                    if(!url.startsWith(origin, true)) return false;

                    var href = S(this.href().substr(origin.length).split('#')[0]);
                    url = S(url.substr(origin.length).split('#')[0]);

                    //if enableSearchParams != true, changing search params does not trigger page load
                    if(!enableSearchParams) {
                        href = S(href.split('?')[0]);
                        url = S(url.split('?')[0]);
                    }

                    return href.trim('/').eq(url.trim('/'), true);
                },
                //determine if the given url is the current host
                isCurrentHost: function(url) {
                    var hostname = _.first(S(url).trim().ensureRight('/').match(fpUtil.regExp.matchHost));
                    return hostname ? S(hostname).contains(loc.hostname) : true;
                }
            });

            return location;
        })(),
        routeManager = {
            urlParams: fpUtil.urlParams(),
            searchParams: fpUtil.urlParams({includeRouteSearch: false}),
            hasXhrPageLoad: window.XhrMagic != null,
            ensureRoute: function(toState, toParams) {
                var url;

                if (toState) toParams = _.getObject(toParams, {});
                else {
                    url = loc.href;
                    var parsedState = stateManager.getStateFromUrl(url, false, true);
                    toState = parsedState.state;
                    toParams = _.getObject(toParams, parsedState.params);
                }

                var redirectToState;

                if(stateManager.is(fpConfig.routeStates.logout, toState)) {
                    fp.trigger(fp.events.ACCOUNT_LOGOUT);
                    //fp.isUnloading = true;
                    redirectToState = stateManager.root;
                }
                else {
                    var data = _.getObject(toState.data),
                        isAuthenticated = fpUtil.isAuthenticated();
                        // , isAuthorized;

                    if(isAuthenticated) {
                        if (!data.authenticate && data.isAuthenticatedRedirect) {
                            redirectToState = stateManager.get(data.isAuthenticatedRedirect);
                            if (redirectToState) stateManager.go(redirectToState);
                        }
                    }
                    else if(data.authenticate) {
                        if(fpConfig.guestCheckOut.enabled) {
                            redirectToState = '/';
                            stateManager.go(redirectToState, null, {absolute: true});
                        }
                        else {
                            redirectToState = stateManager.get(toState.data.loginState) || stateManager.get('login');
                            this.redirect(redirectToState, {
                                error: fpUi.locale('ui-sign-continue', 'Please sign in to continue.')
                            }, toState, toParams);
                        }
                    }

                    // else if (!data.authenticate && !data.authorize) return;
                }

                if(!redirectToState && toState.redirect) {
                    var redirect = _.result(toState, 'redirect');
                    if(_.isObject(redirect) && redirect.state) {
                        redirectToState = redirect.state;
                        if(_.size(redirect.params)) toParams = redirect.params;
                    }
                    else {
                        redirectToState = redirect == 'first-child' ? _.first(toState.menu) : stateManager.get(redirect);
                    }

                    //we can remove this when we convert all WP sites to use parameter style
                    var toOptions;
                    if(_.isString(toState.redirect)) {
                        var name = S(toState.redirect);
                        if(name.endsWith('-param') || name.endsWith('-route')) {
                            toOptions = {
                                disableHistory: true
                            };
                        }
                    }
                    if(redirectToState) stateManager.go(redirectToState, toParams, toOptions);
                }

                // fp.log('data:', data, 'isAuthenticated:', isAuthenticated, 'isAuthorized:', isAuthorized);
                if(redirectToState) {
                    return {
                        toState: redirectToState,
                        fromState: toState,
                        fromParams: toParams
                    };
                }
            },
            href: function(urlMatcher, params, options) {
                if(!urlMatcher) return;

                if(options && options.debug) debugger;

                params = _.getObject(params);
                options = _.getObject(options);
                if(options.enableSearchParams) filterSearchParams(params);

                var routeDelimiter = fp.routeDelimiter + '/',
                    url;

                if(_.isString(urlMatcher)) {
                    url = S(urlMatcher).trailingSlashIt();
                    if(url.endsWith(fp.routeDelimiter)) url = url.ensureRight('/');
                    else if(!url.contains(fp.routeDelimiter)) url = url.concat(routeDelimiter);

                    if(_.size(params)) url = url.concat(fpUtil.urlSearch(params));
                }
                else {
                    if (!urlMatcher.validates(params)) return;

                    //fp.log(urlMatcher, params, options.filtered);

                    url = S(urlMatcher.format(params, !options.filtered));

                    //if (url !== null) {
                    //    url = fp.routeDelimiter + url;
                    //
                    //    // Handle special hash param, if needed
                    //    if (params && params[fp.routeDelimiter]) url += fp.routeDelimiter + params[fp.routeDelimiter];
                    //}
                }

                //if(fp.loaded && routeManager.searchParams.offer_id) {
                //    debugger;
                //}

                if(options.enableSearchParams && _.size(routeManager.searchParams)) {
                    var urlParts = url.split(routeDelimiter);
                    urlParts[0] += urlParts[0].indexOf('?') >= 0 ? '&' : '?';
                    url = S(urlParts.join()).concat(S(fpUtil.urlSearch(routeManager.searchParams)).trimLeft('?') + routeDelimiter);
                }
                else if(options.disableRouteParams) {
                    url = url.replace(routeDelimiter, S().trailingSlashIt().s);
                }

                url = url.ensureLeft('/');

                //if(fpConfig.enableSEO && options.enableSEO && options.slug) {
                //    url = url.replace(routeDelimiter, S(options.slug).ensureLeft('/').trailingSlashIt().s);
                //}

                var origin = '';
                if(fpConfig.enableRouteDomain) {
                    if(!this.origin) this.origin = fp.isLocal() ? routerLocation.origin() : S(_.getObject(fpUtil.map.get('spcStoreSetting').get('site_url').config).home_url).trimRight('/').s;
                    origin = this.origin;
                }
                else if(options.absolute) origin = routerLocation.origin();
                
                return origin + url.s;
            },
            buildUrl: function(url, options) {
                url = S(url || loc.href);
                options = $.extend({inherit: false}, options);

                var searchParams,
                    routeSearchParams,
                    urlSearch,
                    urlRouteSearch,
                    temp = url.split(fp.routeDelimiter),
                    baseUrl = S(temp[0].split('?')[0]),
                    route = S(S(temp[1]).split('?')[0]).trim('/');

                if(options.inherit && url.contains('?')) {
                    if(options.searchParams) {
                        searchParams = fpUtil.urlParams({url: url.s, includeSearch: true, includeRouteSearch: false});
                    }
                    if(options.routeSearchParams && url.contains(fp.routeDelimiter)) {
                        routeSearchParams = fpUtil.urlParams({url: url.s, includeSearch: false, includeRouteSearch: true});
                    }
                }

                searchParams = _.getObject(searchParams);
                _.each(options.searchParams, function (value, key) {
                    if (fpUtil.isNull(value)) {
                        delete searchParams[key];
                        return;
                    }
                    searchParams[key] = value;
                });

                urlSearch = fpUtil.urlSearch(searchParams);

                routeSearchParams = _.getObject(routeSearchParams);
                _.each(options.routeSearchParams, function (value, key) {
                    if (fpUtil.isNull(value)) {
                        delete routeSearchParams[key];
                        return;
                    }
                    routeSearchParams[key] = value;
                });

                urlRouteSearch = fpUtil.urlSearch(routeSearchParams);
                if(route.length || urlRouteSearch) {
                    route = route.prepend(fpUtil.formatString('{0}/', fp.routeDelimiter));
                }

                if(urlRouteSearch) route = route.ensureRight('/').append(urlRouteSearch);

                if(fpUtil.regExp.matchHost.test(baseUrl.ensureRight('/').s)) {
                    if(!baseUrl.match(/\.[a-z]{3,4}$/i)) baseUrl = baseUrl.ensureRight('/');
                }
                else {
                    baseUrl = baseUrl.ensureLeft('/');
                    if(!baseUrl.match(/\.[a-z]{3,4}$/i)) baseUrl = baseUrl.trailingSlashIt();
                }

                return baseUrl.append(urlSearch).append(route).s;
            },
            redirect: function(toState, toParams, nextState, nextParams) {
                if(!_.isObject(toState)) return;

                toParams = _.getObject(toParams);
                var stateManager = uiRouter.stateManager;

                if(stateManager.current.name == toState.name && _.isEqual(toParams, stateManager.stateParams)) {
                    return;
                }

                nextState = nextState || stateManager.current;
                nextParams = nextParams || stateManager.stateParams;

                if(nextState /*&& !nextState.abstract*/) {
                    toParams.next = stateManager.href(nextState.name, nextParams);
                }

                stateManager.go(toState, toParams);
            },
            //return a local route if the given url has a local state/route
            getLocalRoute: function(url) {
                url = S(url).trim();
                if(url.length && !stateManager.getStateFromUrl(url.s).state.abstract) {
                    var host = _.first(url.ensureRight('/').match(fpUtil.regExp.matchHost));
                    if(host) url = url.trimLeft(host).ensureLeft('/');
                    return url.s;
                }
            },
            relativeUrl: function(url, ensureLocale) {
                url = S(url).trim().ensureRight('/').replace(fpUtil.regExp.matchHost, '').ensureLeft('/').trailingSlashIt().s;

                if (ensureLocale && fpConfig.enableLocale && fp.locale && S(loc.pathname).ensureRight('/').startsWith('/' + fp.locale + '/')) {
                    url = '/' + fp.locale + url;
                }

                //if enableRouteDomain is set we cannot use relative URL
                if(fpConfig.enableRouteDomain && uiRouter.routeManager.origin) {
                    url = uiRouter.routeManager.origin + url;
                }
                
                return url;
            },
            locale: function(href) {
                if (!href) href = loc.href;
                var matches = href.match(fpUtil.regExp.matchUrl),
                    lang = matches && matches[3],
                    locales = fpConfig.locales || fp.locales,
                    locale;
                if (lang && _.contains(locales, lang)) locale = lang;
                if (!locale) locale = _.first(locales) || 'en';
                return locale;
            }
        },
        stateManager = {
            states: {},
            stateParams: {},
            rootStateConfig: {
                name: '',
                url: '^',
                views: null,
                'abstract': true,
                data: {}
            },
            //self managing history
            history: (function () {
                if(
                    document.referrer &&
                    _.getArray(document.referrer.match(fpUtil.regExp.matchUrl))[1] != routerLocation.origin()
                ) {
                    fp.setCookie('fp-history', null);
                }

                var maxLength = 4,
                    items = fp.getCookie('fp-history');

                return {
                    __items: function() {
                        return fp.getCookie('fp-history');
                    },
                    get: function (state) {
                        var item;
                        if(fpUtil.isInteger(state)) {
                            var index = state;
                            if(index < 0) index = _.size(items) - 1 + index;
                            item = items[index];
                        }
                        else {
                            if (_.isObject(state)) state = state.name;
                            item = _.findWhere(items, {name: state});
                        }
                        return item;
                    },
                    add: function (value) {
                        if (!(_.isObject(value) && _.has(value, 'name'))) return;
                        this.remove(value.name, false);
                        items[_.size(items)] = value;

                        var length = _.size(items);
                        if (length > maxLength) {
                            for (var n = 0; n < length - maxLength; n++) {
                                delete items[n];
                            }
                            indexItems();
                        }

                        fp.setCookie('fp-history', items);
                    },
                    remove: function (name, setCookie) {
                        setCookie = fpUtil.getBoolean(setCookie, true);
                        var attrs = {
                                name: name
                            },
                            item;

                        _.find(items, function (value, key) {
                            if (_.isMatch(value, attrs)) {
                                item = value;
                                delete items[key];
                                return true;
                            }
                            return false;
                        });

                        //fp.log(name, item, items);
                        indexItems();
                        if (setCookie) fp.setCookie('fp-history', items);

                        return item;
                    },
                    flush: function () {
                        _.empty(items);
                        fp.setCookie('fp-history');
                    },
                    back: function (state, params, options) {
                        var item = this.get(state),
                            stateParams;

                        if (item) stateParams = item.stateParams;

                        return uiRouter.stateManager.go(state, $.extend(stateParams, params), options);
                    },
                    //href: function (state, params, options) {
                    //    var item,
                    //        stateParams;
                    //
                    //    if(state) {
                    //        if(_.isString(state) && S(state).startsWith('/')) {
                    //
                    //        }
                    //        else entry = this.get(state);
                    //    }
                    //    else {
                    //        var parent = uiRouter.stateManager.getTopParent(uiRouter.stateManager.current),
                    //            nextParent,
                    //            item;
                    //
                    //        for (var n = _.size(items) - 1; n >= 0; n--) {
                    //            item = items[n];
                    //            if((nextParent = uiRouter.stateManager.getTopParent(item.name)) != parent) {
                    //                entry = item;
                    //                state = uiRouter.stateManager.get(entry.name);
                    //                break;
                    //            }
                    //        }
                    //    }
                    //
                    //    if (entry) stateParams = entry.stateParams;
                    //
                    //    return state ? uiRouter.stateManager.href(state, $.extend(stateParams, params), options) : '';
                    //}
                    href: function (state, params, options) {
                        var item = this.get(state),
                            stateParams;

                        if (item) stateParams = item.stateParams;

                        return uiRouter.stateManager.href(state, $.extend(stateParams, params), options);
                    }
                };

                function indexItems() {
                    var copy = {},
                        index = 0;

                    _.each(items, function (value) {
                        copy[index] = value;
                        index++;
                    });

                    items = copy;
                }
            })(),
            register: function(states) {
                states = states ? states : [];
                var self = this;

                this.initRootState();

                if(routeManager.urlParams.disableRoutes == 'true') {
                    this.from = this.root;
                    this.current = this.getStateFromUrl().state;
                    this.currentUrl = loc.href;
                    return;
                }

                _.each(states, function(item) {
                    if(S(item.url).startsWith('{{')) return;

                    self.ensureState(item.menuParent, states);
                    self.ensureState(item.parent, states);

                    if(item.parent && !self.get(item.parent)) return;
                    if(self.get(item.name)) return;

                    self.registerState(item);
                });

                //sort each state's menu
                _.each(this.states, function(item) {
                    fpUtil.sort(item.menu, 'menuSequence');
                });

                var parsedState = this.getStateFromUrl(null, false, true);

                this.from = this.root;
                this.current = parsedState.state;
                this.currentUrl = loc.href;

                $.extend(this.stateParams, parsedState.params);
            },
            init: function() {
                if(this.initialized) {
                    if(routeManager.hasXhrPageLoad) {
                        this.initRootState();

                        onRouterBefore.call(this, true, null);
                    }

                    return;
                }

                this.from = this.current = this.root;
                delete this.fromUrl;

                //this.cachedState = getCurrentState();

                if(fpConfig.enableSEOPushState && !fp.isBot && fpConfig.enableSEO && window.history && window.history.pushState) {
                    //fp.Router (director) is only set up for hash change so we need to add a listener for popstate

                    var onStateChange = function(event) {
                        if (
                            event.isDefaultPrevented() ||
                            $(event.target).closest('.disable-freshop-xhr-url,[disable-freshop-xhr-url]').length
                        ) {
                            return;
                        }

                        var href = this.href || loc.href,
                            compareUrl = event.type == 'popstate' ? stateManager.currentUrl : href;

                        if(!routerLocation.isCurrentPage(compareUrl)) {
                            stateManager.go(href, null, {absolute: true, event: event});
                        }
                    };

                    $(window)
                        .off('popstate.stateManager')
                        .on('popstate.stateManager', onStateChange);

                    $(document.body)
                        .off('click.stateManager')
                        .on('click.stateManager', 'a[href], [data-freshop-xhr-url]', onStateChange);
                }

                //trigger on all route changes
                if(!this._router) {
                    this._router = fp.Router({'/.*': $.noop});
                    this._router.configure({
                        async: true,
                        //this is triggered on leaving a route/state and before entering a new route/state
                        after: $.proxy(onRouterAfter, this),
                        //this is triggered before entering a route/state
                        before: $.proxy(onRouterBefore, this),
                        //this is triggered on entering a route/state
                        on: $.proxy(onRouterOn, this)
                    });
                }
                this._router.init('/');
                this.initialized = true;
            },
            initRootState: function() {
                if(this.rootStateConfig.url === '^') {
                    //replace invalid characters within pathname
                    fpUtil.regExp.matchJsonXssInvalidChars.lastIndex = 0;
                    const pathname = decodeURI(fpUtil.decodeForHtml(routerLocation.pathname())).replace(fpUtil.regExp.matchJsonXssInvalidChars, '');
                    this.rootStateConfig.url = fpUtil.formatString('^{0}{1}/', pathname, fp.routeDelimiter);
                }

                if(this.root) {
                    this.root.self.url = this.rootStateConfig.url;
                    this.rebuildState(this.root, false);
                    return;
                }

                this.root = this.registerState(this.rootStateConfig);
            },
            registerState: function(item, options) {
                options = _.getObject(options);

                //var existingState;
                //if(options.enableOverwrite) {
                //    existingState = this.get(item);
                //}

                var self = this,
                    state = this.generateState(item, options),
                    url = S(item.url);

                this.states[item.name] = state;

                if(!state.abstract) {
                    if (!(fpConfig.enableSEO && state.enableSEO && state.ownParams && state.ownParams.slug) && url.startsWith('?') && !url.startsWith('?{')) {
                        var requiredParams = url.trimLeft('?').split('&');
                        if (requiredParams.length) {
                            state.requiredParams = _.getObject(state.requiredParams);

                            var params;
                            _.each(requiredParams, function (value) {
                                params = value.split('=');
                                state.requiredParams[S(params[0]).trim().s] = S(params[1]).trim().s || null;
                            });
                        }
                    }

                    _.each(item.params, function (value, key) {
                        if (key == 'lang' || (fpConfig.enableSEO && state.enableSEO) || (state.requiredParams && _.has(state.requiredParams, key))) {
                            return;
                        }

                        state.requiredParams = _.getObject(state.requiredParams);
                        state.requiredParams[key] = value || null;
                    });

                    if(state.parent) {
                        state.parent.children.push(state);

                        if(!state.menuParent) state.parent.menu.push(state);
                    }

                    if(state.menuParent) {
                        _.each(state.menuParent.split(','), function(menuParent) {
                            menuParent = self.get(menuParent);
                            if(menuParent) menuParent.menu.push(state);
                        });
                    }
                }

                return state;
            },
            generateState: function(item, options) {
                options = _.getObject(options);

                if(!options.disableValidate && (!_.isString(item.name) || item.name.indexOf('@') >= 0)) {
                    throw new Error('State must have a valid name');
                }
                if(!(options.disableValidate /*|| options.enableOverwrite*/) && this.states.hasOwnProperty(item.name)) {
                    throw new Error(fpUtil.formatString('State "{0}" is already defined', item.name));
                }

                var state = $.extend({}, item, {
                    self: item,
                    //resolve: item.resolve || {},
                    toString: function () {
                        return this.name;
                    }
                });

                for (var key in stateBuilder) {
                    if (_.isFunction(stateBuilder[key])) {
                        state[key] = stateBuilder[key](state);
                    }
                }

                return state;
            },
            rebuildState: function(item, deep) {
                var state = this.get(item);
                if(!state) return;

                deep = fpUtil.getBoolean(deep, true);

                for (var key in stateBuilder) {
                    if(_.has(state.self, key)) state[key] = state.self[key];
                    else if(key != 'menu' && key != 'children') delete state[key];
                }

                for (var key in stateBuilder) {
                    if (key != 'menu' && key != 'children' && _.isFunction(stateBuilder[key])) {
                        state[key] = stateBuilder[key](state);
                    }
                }

                if(deep) {
                    var isRebuilt = {};
                    isRebuilt[state.name] = 1;

                    _.each(state.children, childIteratee);
                    _.each(state.menu, childIteratee);

                    function childIteratee(item) {
                        if (isRebuilt[item.name]) return;

                        stateManager.rebuildState(item);
                        isRebuilt[item.name] = 1;
                    }
                }

                return state;
            },
            ensureState: function(state, states) {
                if(!_.isString(state) || !_.isObject(states)) return;

                state = _.findWhere(states, {name: state});
                if(!state) return;
                if(this.get(state.name)) return;

                if(state.name == state.parent) {
                    fp.warn(fpUtil.formatString('Circular reference detected for state "{0}".', state.name));
                    return;
                }

                this.ensureState(state.parent, states);
                if(state.parent && !this.get(state.parent)) return;

                this.registerState(state);
            },
            get: function(state) {
                if(_.isObject(state)) {
                    if(state.url instanceof uiRouter.UrlMatcher) return state;
                    else state = state.name;
                }

                //if(state && fpConfig.enableSEO && state.enableSEO && !S(state.name).endsWith('-route')) {
                //    var connectedState = this.states[state.name + '-route'];
                //    if(connectedState) state = connectedState;
                //}

                return _.isString(state) ? this.states[state] : undefined;
            },
            getTopParent: function(state) {
                state = this.get(state);

                if(!_.isObject(state)) return;

                while(state.parent && !state.parent.abstract) {
                    state = state.parent;
                }

                return state;
            },
            contains: function(state, parent) {
                state = this.get(state);
                if(!_.isObject(state)) return false;

                parent = this.get(parent);
                if(!_.isObject(parent)) return false;

                var contains = false;

                while(state && !state.abstract) {
                    contains = this.is(state, parent);
                    if (contains) break;

                    state = state.parent;
                }

                return contains;
            },
            hasLineage: function(stateA, stateB) {
                return this.getTopParent(stateA) == this.getTopParent(stateB || this.current);
            },
            getStateFromUrl: function(url, enableGenerate, enableParams, debug) {
                if(debug) debugger;
                var routeDelimiter = fp.routeDelimiter + '/',
                    parsedUrl = parseUrl(url, enableParams),
                    routeParsedUrl = S(parsedUrl.url)
                        .replace(routeDelimiter, '')
                        .trailingSlashIt().s,
                    tempUrl,
                    slug,
                    toState,
                    toParams,
                    toSlug,
                    stateParams,
                    hasRequiredParams;

                //fp.log(parsedUrl);
                //find the last state with params that match URL's params
                _.find(this.states, function(state) {
                    if (state.abstract) return;

                    if (fpConfig.enableSEO && state.enableSEO && state.ownParams && state.ownParams.slug) {
                        tempUrl = routeParsedUrl;
                    }
                    else tempUrl = parsedUrl.url;

                    if(debug && S(state.name).startsWith('product-detail')) debugger;

                    if(!S(tempUrl).startsWith(state.url.prefix)) return;

                    stateParams = state.url.exec(tempUrl, parsedUrl.params);

                    if (!_.isObject(stateParams)) return;

                    if(_.size(state.requiredParams)) {
                        hasRequiredParams = true;

                        _.find(state.requiredParams, function (value, key) {
                            // fp.log(value, parsedUrl.params[key], state);

                            if (!_.has(parsedUrl.params, key) || (_.size(value) && value != parsedUrl.params[key])) {
                                hasRequiredParams = false;
                                return true;
                            }
                        });

                        if(hasRequiredParams) {
                            toState = state;
                            toParams = stateParams;
                            toSlug = slug;
                            return true;
                        }

                        return;
                    }

                    toState = state;
                    toParams = stateParams;
                });

                if(_.isObject(toState)) {
                    $.extend(parsedUrl.params, toParams);

                    if(toState.mapToParentState) toState = toState.parent;

                    var name = S(toState.name);
                    if(name.endsWith('-param') || name.endsWith('-route')) {
                        // fp.log('toState', toState);
                        var connectedState = this.get(toState.name.replace('-param', '').replace('-route', ''));
                        if (connectedState) toState = connectedState;
                    }
                }

                if(!_.isObject(toState)) {
                    toState = this.root;
                    toParams = toState.url.exec(parsedUrl.url, parsedUrl.params);
                    $.extend(parsedUrl.params, toParams);
                }

                if(toState == this.root && enableGenerate) {
                    url = S(url);
                    if(!url.contains(fp.routeDelimiter)) {
                        url = url.trailingSlashIt().concat(fp.routeDelimiter);
                    }
                    url = url.ensureRight('/');
                    toState = this.generateState({url: url.s}, {disableValidate: true});
                }

                return {
                    state: toState,
                    params: parsedUrl.params,
                    options: (fpConfig.enableSEO && toState.enableSEO) ? toSlug && {slug: toSlug} : undefined
                };
            },
            getCategoryState: function(navigationPath, type) {
                var state;

                if(_.isObject(navigationPath)) {
                    if(navigationPath.canonical_url) {
                        state = this.getStateFromUrl(navigationPath.canonical_url).state;
                        if(state) return state;
                    }

                    navigationPath = navigationPath.js_navigation_path;
                }

                if(!navigationPath) {
                    if(type && _.has(fpConfig.routeStates, type)) {
                        state = this.get(fpConfig.routeStates[type]);
                    }
                    if(!state) state = this.current;
                    return state;
                }

                if(routerLocation.isCurrentPage(navigationPath)) state = this.current;
                else {
                    state = this.getStateFromUrl(navigationPath, true).state;
                }

                return state;
            },
            getQ: function() { //find first search term value where state param equals 'q' or ends with '_q'
                var returnValue;
                _.find(this.stateParams, function(value, key) {
                    key = S(key);
                    if(key.eq('q') || key.endsWith('_q')) {
                        returnValue = {
                            identifier: key.s,
                            value: S(value).trim().s
                        };
                        return true;
                    }
                });

                return returnValue || {
                        identifier: 'q',
                        value: ''
                    };
            },
            go: function(to, params, options) {
                //fp.log('from', loc.href);
                //fp.log('stateManager.go', to, params, options);
                //fp.logStack('stateManager.go'/*, to, params, options*/);
                options = _.getObject(options);

                var goTo = to,
                    isChanging = false,
                    isCurrentPage,
                    enableSeo,
                    href;

                if(_.isString(goTo) && options.absolute) {
                    var parsedState = this.getStateFromUrl(goTo, false, true);

                    //don't process call triggered by event if SEO is not enabled
                    if(options.event && !(fpConfig.enableSEOPushState && fpConfig.enableSEO && parsedState.state.enableSEO)) {
                        return isChanging = true;
                    }

                    if(!parsedState.state.abstract) {
                        var redirect = routeManager.ensureRoute(parsedState.state, params);
                        if (redirect) return isChanging;

                        if (!params) params = parsedState.params;

                        goTo = parsedState.state;

                        href = this.href(goTo, params, options);
                    }
                    else href = goTo;
                }
                else {
                    goTo = this.get(goTo);
                    if (!_.isObject(goTo)) return isChanging;

                    href = this.href(goTo, params, options);

                    if(options.reloadState && routerLocation.isCurrentPage(href)) {
                        onRouterBefore.call(this, true, null);
                        return isChanging;
                    }
                }

                if(!href) return isChanging;

                if(!options.absolute) {
                    isChanging = !_.isEqual(fpUtil.urlParams(href), routeManager.urlParams);
                }

                var preventDefault = fpUtil.getBoolean(options.preventDefault || options.reload, false),
                    disableHistory = _.has(options, 'disableHistory') ? options.disableHistory : preventDefault;

                if(_.isObject(goTo)) {
                    enableSeo = fpConfig.enableSEO && goTo.enableSEO;
                    if (enableSeo) {
                        if (fpConfig.enableSEOPushState) isCurrentPage = this.getTopParent(goTo) == this.getTopParent(this.current);
                        else isCurrentPage = this.contains(goTo, this.current) || this.contains(this.current, goTo);
                    }
                }

                if(!enableSeo) isCurrentPage = routerLocation.isCurrentPage(href, options.absolute);

                if(preventDefault) this.preventDefault = preventDefault;

                if(options.reload || (!routeManager.hasXhrPageLoad && !isCurrentPage && !options.enableReplaceState)) {
                    fp.isUnloading = freshop.unloading = true;
                }

                //fp.log('stateManager.go', href);

                var hasHistory = window.history && window.history.replaceState;
                if (!fp.isUnloading && hasHistory && disableHistory) {
                    var origin = routerLocation.origin();
                    if(fpConfig.enableRouteDomain && routeManager.origin && routeManager.origin != origin && S(href).contains(routeManager.origin)) {
                        href = href.replace(routeManager.origin, origin);
                    }
                    window.history.replaceState({}, null, href);
                    onRouterBefore.call(this, true, null);
                }
                else {
                    if (routeManager.hasXhrPageLoad) {
                        fp.__$freshop.find('a[data-role="next"]').attr('href', href)[0].click();
                    }
                    //else if(hasHistory && enableSeo) {
                    //    debugger;
                    //    if(options.canonical_url && options.href) href = options.href;
                    //    window.history.pushState({}, document.title, href);
                    //    onRouterBefore.call(this);
                    //}
                    else if(options.absolute || routerLocation.pathname(true) != href) {
                        if(fpConfig.enableSEOPushState && _.isObject(goTo) && routerLocation.pathname() != href.split('#')[0]) {
                            var fromHref = href,
                                fromLocale,
                                toLocale;

                            if(_.isString(to)) fromHref = to;

                            if (fpConfig.enableLocale) {
                                fromLocale = fp.locale;
                                toLocale = routeManager.locale(fromHref);
                            }

                            if (
                                S(fromLocale).eq(toLocale, true) &&
                                goTo.enableSEO &&
                                this.current.enableSEO &&
                                this.hasLineage(goTo, this.current)
                            ) {
                                var departmentId = params && params.department_id,
                                    department = (departmentId && fp.departmentHash[departmentId]) || fp.defaultDepartment,
                                    recipeCategories = fpUtil.map.get('recipeCategory', null, true),
                                    categoryId = this.stateParams.category_id || fp.moduleCategoryId,
                                    category = (categoryId && recipeCategories.get(categoryId)) || fp.defaultCategory
                                    nextCategoryId = params && params.category_id,
                                    nextCategory = (nextCategoryId && recipeCategories.get(nextCategoryId)) || fp.defaultCategory;

                                if (
                                    S(department.js_navigation_path).eq(fp.department.js_navigation_path, true) &&
                                    S(nextCategory.js_navigation_path).eq(category.js_navigation_path, true)
                                ) {
                                    if (fpUtil.getValueFromNamespace('event.type', options) != 'popstate') {
                                        window.history.pushState({}, document.title, fromHref);

                                        fpService.urlService
                                            .get({
                                                g: fromHref,
                                                locale: toLocale,
                                                store_id: fp.topStore.id
                                            }, {
                                                childServiceCall: 'analyze',
                                                timeout: 2000,
                                                handleErrors: false
                                            })
                                            .done(function (resp) {
                                                if (resp.title) document.title = fpUtil.decodeForHtml(resp.title);
                                            });
                                    }

                                    if(options.event) options.event.preventDefault();
                                    onRouterBefore.call(this);

                                    if(options.reload && isCurrentPage) loc.reload();
                                    return isChanging = true;
                                }
                            }

                            if(options.event) {
                                if(options.reload && isCurrentPage) loc.reload();
                                return isChanging = true;
                            }
                        }

                        if(options.log) fp.log(href);
                        else loc.href = href;
                    }
                }

                if(options.reload && isCurrentPage) {
                    if(options.log) fp.log(loc.href);
                    else loc.reload();
                }

                //need to cleanup preventDefault in timeout as onRouterBefore may never be triggered
                if(this.preventDefault) {
                    isChanging = false;
                    var self = this;
                    setTimeout(function () {
                        delete self.preventDefault;
                    }, 100);
                }

                return isChanging;
            },
            href: function(state, params, options) {
                state = this.get(state);

                if(!_.isObject(state)) return '';

                if(fpConfig.enableSEO && state.enableSEO && !S(state.name).endsWith('-route')) {
                    var connectedState = this.states[state.name + '-route'];
                    if(connectedState) state = connectedState;
                }

                // if(state.data.enableOauthLoginUrl) {
                //     href = fp.ui.getOauthLoginUrl();
                //     if(href) return href;
                // }

                //route is set to '#', build href from current state
                if(state.url.source == fpUtil.formatString('/{0}/#', fp.routeDelimiter)) {
                    state = this.current;
                    params = $.extend({}, this.stateParams);
                }

                var enableSlug = fpConfig.enableSEO && state.enableSEO && options && _.has(options, 'canonical_url'),
                    stateParams = this.stateParams,
                    prefix;

                options = $.extend({
                    lossy: true,
                    inherit: false,
                    relative: this.current,
                    absolute: false,
                    filtered: false,
                    enableSEO: fpConfig.enableSEO && state.enableSEO
                }, options);

                state = (state && options.lossy) ? state.navigable : state;

                if(!state) return '';

                params = _.getObject(params);

                if(options.inherit) {
                    //ideally the filtered option would not exist and all stateParams would be derived through the inheritParams function
                    if(fpConfig.enableSEO && state != this.current) {
                        params = $.extend(params, {slug: null, route: null});
                    }

                    if(options.filtered) params = inheritParams(stateParams, params, this.current, state);
                    else params = $.extend({}, stateParams, params);
                    //else if(this.getTopParent(state) == this.getTopParent(this.current)) params = $.extend({}, stateParams, _.getObject(params));
                }
                else if(options.enableSEO && state == this.current) {
                    _.each(state.ownParams, function (param) {
                        if (param.id != 'route' && !_.has(params, param.id) && _.has(stateParams, param.id)) {
                            params[param.id] = stateParams[param.id];
                        }
                    });
                }

                if(options.debug) debugger;

                if(fpConfig.enableLocaleRoute) {
                    var inheritedParams,
                        keys,
                        param,
                        locale;

                    if(state.abstract) {
                        inheritedParams = state.ownParams;
                        keys = _.keys(inheritedParams);
                    }
                    else {
                        inheritedParams = state.params;
                        keys = state.params.$$keys();
                    }

                    _.each(keys, function (key) {
                        param = inheritedParams[key];
                        if (param && param.config.inherit && !_.has(params, key)) {
                            params[key] = stateParams[key];
                        }
                    });

                    if (_.has(params, 'lang')) {
                        locale = params.lang;
                        if(locale) {
                            if(locale.length == 2) {
                                params.lang = fpUtil.formatString('{0}-{0}', locale);
                            }
                            else {
                                locale = params.lang.split('-')[0];
                                if(fpUtil.formatString('{0}-{0}', locale) != params.lang) {
                                    locale = params.lang;
                                }
                            }
                        }

                        if (!locale || !_.contains(fpConfig.locales, locale)) {
                            delete params.lang;
                            locale = null;
                        }
                    }
                    if(params.route) params.route = S(params.route).ensureLeft('/').s;
                    //delete params.__url;
                }

                if(enableSlug) {
                    if(options.canonical_url) {
                        prefix = S(state.url.segments[fpConfig.enableLocaleRoute ? 1 : 0]).trimRight(fp.routeDelimiter + '/');
                        var match = options.canonical_url.match(fpUtil.regExp.matchCanonicalUrl);
                        params.slug = S(match && match[2]);
                        if(params.slug.startsWith(prefix)) {
                            params.slug = params.slug.trimLeft(prefix);
                            prefix = null;
                        }
                        
                        //overwrite department landing page paths for mobile site
                        if(fpConfig.enableMobile) {
                            var departmentId = params.department_id,
                                department = departmentId && fp.departmentHash[departmentId];
                            if(department && department.__origJsNavPath) {
                                params.slug = params.slug.replace(department.__origJsNavPath, fpConfig.urls.shopping);
                            }
                        }

                        params.slug = params.slug.trimLeft('/').s;
                    }

                    if(params.id) {
                        if(_.has(state.params, 'product_id')) {
                            params.product_id = params.id;
                            delete params.id;
                        }
                        else if(_.has(state.params, 'recipe_id')) {
                            params.recipe_id = params.id;
                            delete params.id;
                        }
                    }
                }

                var filteredParams = options.filtered ? filterByKeys(state.params.$$keys(), params) : params,
                    href = S.getString(routeManager.href(state.url, filteredParams, options));

                if(locale && locale != filteredParams.lang) {
                    if(!fpConfig.enableLocaleRoute) href = S(href).ensureLeft('/').s;
                    href = href.replace('/' + filteredParams.lang + '/', '/' + locale + '/');
                }

                if(prefix) href = S(href).trimLeft(prefix.trimRight('/').s).s;
                if(fpConfig.enableSEO && state.enableSEO && state.ownParams && state.ownParams.slug && href.indexOf('#') == -1) {
                    var routeDelimiter = fp.routeDelimiter + '/';
                    if(href.indexOf('?') >= 0) {
                        href = href.replace('?', fpUtil.formatString('{0}{1}?', S().trailingSlashIt().s, routeDelimiter));
                    }
                    else if(loc.hash.indexOf('#') >= 0) {
                        href = S(href).trailingSlashIt().s + routeDelimiter;
                    }

                    if(_.size(options.searchParams)){
                        var temp = href.split(routeDelimiter);
                        temp.push(fpUtil.urlSearch(options.searchParams), routeDelimiter, temp.pop());
                        href = temp.join('');
                    }
                }
                //without slug there is a double slash
                //if(enableSlug && !params.slug) {
                //    href = href.replace(state.url.prefix + '/', state.url.prefix);
                //}

                //removing ending hash (for current page) unless already set
                if(!routerLocation.isCurrentPage(href) || loc.hash.indexOf('#') == -1) {
                    href = S(href).trimRight(fpUtil.formatString('{0}{1}/', S().trailingSlashIt().s, fp.routeDelimiter));

                    if(!href.contains('#')) href = href.trailingSlashIt();
                    href = href.s;
                }

                //if(stateParams.lang && stateParams.lang != 'en-us') {
                //    href = stateParams.lang + '/' + href;
                //}

                return href;
            },
            categoryHref: function(item, options, stateParams, stateOptions) {
                var hasId = item && item.id/* && item.parent_id*/,
                    params = stateParams,
                    fieldName = 'department_id',
                    categoryHref,
                    defaultNavigationState;

                if(options.enableTemplate && hasId && options.template) {
                    //Use a prebuilt path when we can
                    categoryHref = options.template;
                }
                else {
                    stateParams = _.omit(stateParams, 'department_id', 'category_id', 'coupon_department_id', 'page');
                }

                if(hasId) {
                    //short circuit for canonical_url
                    if(fpConfig.enableSEO && !options.relative && item && item.canonical_url) {
                        defaultNavigationState = this.getStateFromUrl(item.canonical_url).state;
                        if(defaultNavigationState) {
                            stateOptions = _.getObject(stateOptions);
                            stateOptions.canonical_url = item.canonical_url;
                            if(options.type == 'recipe') fieldName = 'category_id';
                            stateParams[fieldName] = item.id;
                            categoryHref = this.href(defaultNavigationState, stateParams, stateOptions);
                            return categoryHref;
                        }
                    }
                    
                    if (!options.js_navigation_path) {
                        if (options.relative) {
                            options.js_navigation_path = S(this.current.self.url).trimLeft('^').trimRight(fp.routeDelimiter + '/').s;
                        }
                        else options.js_navigation_path = fpConfig.urls[options.type];
                    }

                    switch (options.type) {
                        case 'product':
                            defaultNavigationState = this.states.shop;
                            break;
                        case 'circular':
                            delete stateParams.offer_id;
                            break;
                        case 'recipe':
                            fieldName = 'category_id';
                            defaultNavigationState = this.states.recipe;
                            break;
                        case 'coupon':
                            fieldName = 'coupon_department_id';
                            break;
                        // no default
                    }

                    if (defaultNavigationState) {
                        if (!options.js_navigation_path) {
                            options.js_navigation_path = defaultNavigationState.self.url;
                        }

                        options.js_navigation_path = S(options.js_navigation_path)
                            .trimLeft('/{lang:[a-z]{2,2}-[a-z]{2,4}}')
                            .trimRight(fp.routeDelimiter + '/').s;

                        if (categoryHref) {
                            categoryHref = categoryHref.replace(S('/js_navigation_path').trailingSlashIt().s, S((item && item.js_navigation_path) || options.js_navigation_path).trailingSlashIt().s);
                        }
                    }

                    if (categoryHref) {
                        categoryHref = categoryHref.replace(fieldName + '=', fieldName + '=' + item.id);
                    }
                    else {
                        stateParams[fieldName] = item.id;
                        if(options.enableTemplate) {
                            params = $.extend({}, stateParams);
                            params[fieldName] = '';
                        }
                    }
                }

                if(!categoryHref) {
                    //js_navigation_path is only applicable to product type
                    var needsTemplate = options.enableTemplate && hasId && !options.template,
                        jsNavigationPath = needsTemplate ? '/js_navigation_path' : S((item && item.js_navigation_path) || options.js_navigation_path).trimLeft('/{lang:[a-z]{2,2}-[a-z]{2,4}}').trailingSlashIt().s;

                    categoryHref = this.href(
                        this.getCategoryState(
                            fpUtil.getStateValue(options.type == 'product' || options.type == 'recipe', jsNavigationPath),
                            fpUtil.getStateValue(!options.relative, options.type)
                        ),
                        params,
                        stateOptions
                    );

                    if(needsTemplate) {
                        options.template = categoryHref;
                        categoryHref = this.categoryHref(item, options, stateParams, stateOptions);
                    }
                }

                return categoryHref;
            },
            is: function(stateA, stateB) {
                stateA = this.get(stateA);

                if(stateA) {
                    stateB = (stateB && this.get(stateB)) || this.current;
                    return stateA == stateB;
                }
                return false;
            },
            isDetail: function(idKey, toParams) {
                return _.hasAny(_.getObject(toParams, this.stateParams), idKey);
            },
            reload: function() {
                this.go(this.current, $.extend({}, this.stateParams), {reloadState: true});
            },
            back: function(itemType) {
                var currentState = this.current;
                if(this.isDetail(['id', 'product_id', 'recipe_id'])) {
                    if(!currentState.abstract) {
                        var historyState;
                        if (fpConfig.enableSEO) historyState = this.history.get(itemType + '-category');
                        if(!historyState) historyState = this.history.get(itemType != 'recipe' ? 'shop' : itemType);
                        if(historyState) {
                            this.history.back(historyState);
                            return;
                        }
                    }

                    currentState = this.getTopParent(currentState);

                    this.go(currentState);
                    return;
                }

                this.history.back(currentState.parent);
            },
            backHref: function(itemType) {
                var currentState = this.current;
                if(this.isDetail(['id', 'product_id', 'recipe_id'])) {
                    if(!currentState.abstract) {
                        var historyState;
                        if (fpConfig.enableSEO) historyState = this.history.get(itemType + '-category');
                        if(!historyState) historyState = this.history.get(itemType != 'recipe' ? 'shop' : itemType);
                        if(historyState) {
                            return this.history.href(historyState);
                        }
                    }

                    currentState = this.getTopParent(currentState);

                    return this.href(currentState);
                }

                return this.history.href(currentState.parent);
            }
        };

        function parseUrl(url, enableParams) {
            var nextUrl,
                route,
                routeSearch,
                params;

            url = S(url || loc.href).replace(fpUtil.regExp.matchHost, '').ensureLeft('/');

            if (fpConfig.enableLocaleRoute) {
                var locale = routeManager.locale(loc.origin + url.s);
                if(locale != 'en' && locale.length == 2) {
                    url = url
                        .trimLeft(fpUtil.formatString('/{0}', locale))
                        .ensureLeft(fpUtil.formatString('/{0}-{0}', locale));
                }

            }

            //allow mapping of route from old order edit admin state
            if(url.contains('/#/admin/order-edit/')) url = url.replace('/#/admin/order-edit/', '/' + fp.routeDelimiter + '/orders/');

            if(url.indexOf(fp.routeDelimiter) < 0) url = url.concat(fp.routeDelimiter);
            nextUrl = url.s;
            nextUrl = nextUrl.split(fp.routeDelimiter);

            routeSearch = nextUrl[nextUrl.length - 1].split('?');
            route = S(routeSearch[0]).trim('/').s;

            nextUrl = nextUrl[0].split('?');
            nextUrl = S(nextUrl[0]).trailingSlashIt().s + fp.routeDelimiter + '/' + route;

            if(enableParams) params = fpUtil.urlParams(url.s);

            return {
                url: nextUrl,
                params: _.getObject(params)
            };
        }

        function filterByKeys(keys, values, isDefined) {
            var filtered = {};
            _.each(keys, function (name) {
                if(isDefined && _.isUndefined(values[name])) return;

                filtered[name] = values[name];
            });
            return filtered;
        }

        var stateBuilder = {
            // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
            parent: function(state) {
                if(state.abstract) return undefined;
                if (state.parent) return stateManager.get(state.parent);
                // regex matches any valid composite state name
                // would match "contact.list" but not "contacts"
                var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
                return compositeName ? stateManager.get(compositeName[1]) : stateManager.root;
            },
            // inherit 'data' from parent and override by own values (if any)
            data: function(state) {
                state.data = $.extend({}, state.data);

                if(state.name && !state.data.cssClass) state.data.cssClass = fpUtil.formatString('fp-state-{0}', state.name);
                if (state.parent) _.defaults(state.data, state.parent.data);

                return state.data;
            },
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: function(state) {
                var url = state.url,
                    config = {
                        params: _.getObject(state.params),
                        disableConcat: state.disableConcat
                    };

                if (_.isString(url)) {
                    if(state.parent && !state.parent.abstract && state.parent.navigable) {
                        //apply sourcePath patch so that child states that have their own routeDelimiter can use it instead of parent routeDelimiter
                        var sourcePath = state.parent.url.sourcePath;
                        if(config.params.slug) {
                            state.parent.url.sourcePath = S(sourcePath).replace(S(fp.routeDelimiter).trailingSlashIt().s, '').s;
                        }

                        url = state.parent.navigable.url.concat(url, config);

                        state.parent.url.sourcePath = sourcePath;

                        return url;
                    }
                    else {
                        if (url.charAt(0) == '^') url = url.substring(1);
                        return uiRouter.urlMatcherFactory.compile(url, config);
                    }
                }

                if (!url || uiRouter.urlMatcherFactory.isMatcher(url)) return url;
                throw new Error(fpUtil.formatString('Invalid url \'{0}\' in state \'{1}\'', url, state));
            },
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: function(state) {
                return state.url ? state : (state.parent ? state.parent.navigable : null);
            },
            // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
            ownParams: function(state) {
                var params = state.url && state.url.params || new uiRouter.urlMatcherFactory.ParamSet();
                _.each(state.params || {}, function(config, id) {
                    if (!params[id]) params[id] = new uiRouter.urlMatcherFactory.Param(id, null, config, "config");
                });
                return params;
            },
            // Derive parameters for this state and ensure they're a super-set of parent's parameters
            params: function(state) {
                return state.parent && state.parent.params ? $.extend(state.parent.params.$$new(), state.ownParams) : new uiRouter.urlMatcherFactory.ParamSet();
            },
            // If there is no explicit multi-view configuration, make one up so we don't have
            // to handle both cases in the view directive later. Note that having an explicit
            // 'views' property will mean the default unnamed view properties are ignored. This
            // is also a good time to resolve view names to absolute names, so everything is a
            // straight lookup at link time.
            views: function(state) {
                var views = {};
    
                _.each(!_.isUndefined(state.views) ? state.views : { '': state }, function (view, name) {
                    if (name.indexOf('@') < 0) name += '@' + state.parent.name;
                    views[name] = view;
                });
                return views;
            },
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: function(state) {
                return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
            },
            // Speed up $state.contains() as it's used a lot
            includes: function(state) {
                var includes = state.parent ? $.extend({}, state.parent.includes) : {};
                includes[state.name] = true;
                return includes;
            },
            children: function(state) {
                return [];
            },
            menu: function(state) {
                return [];
            }
        };

    function inheritParams(currentParams, newParams, current, to) {
        var parents = ancestors(current, to), parentParams, inherited = {}, inheritList = [];

        for (var n in parents) {
            if (!parents[n].params) continue;
            parentParams = _.keys(parents[n].params);
            if (!parentParams.length) continue;

            for (var z in parentParams) {
                if (_.indexOf(inheritList, parentParams[z]) >= 0) continue;
                inheritList.push(parentParams[z]);
                inherited[parentParams[z]] = currentParams[parentParams[z]];
            }
        }
        return $.extend({}, inherited, newParams);
    }

    function ancestors(first, second) {
        var path = [];

        for (var n in first.path) {
            if (first.path[n] !== second.path[n]) break;
            path.push(first.path[n]);
        }
        return path;
    }

    function filterSearchParams(params) {
        if (_.size(params)) {
            var searchParams = routeManager.searchParams,
                value;
            for (var key in params) {
                value = params[key];
                if (_.has(searchParams, key) && S(value).trim().s === S(searchParams[key]).trim().s) {
                    delete params[key];
                }
            }
        }
        return params;
    }

    //this is triggered when exiting a route/state and before entering a new route/state
    function onRouterAfter() {
        var next = _.getFunction(arguments[arguments.length - 1], $.noop),
            payload = {
                fromState: this.from,
                fromUrl: this.fromUrl
            };

        fp.trigger(fp.events.ROUTE_AFTER_CHANGE, payload);

        if(this.current != this.from) {
            fp.trigger(fp.events.STATE_AFTER_CHANGE, $.extend({}, payload));
        }

        next();
    }

    var isReloadTriggered = false;

    //this is triggered before entering a route/state
    function onRouterBefore() {
        //fp.logStack('onRouterBefore');

        var next = _.getFunction(arguments[arguments.length - 1], $.noop),
            parsedState = this.getStateFromUrl(null, false, true),
            data = parsedState.state.data,
            isDefaultPrevented = fpUtil.getBoolean(this.preventDefault, false);

        delete this.preventDefault;

        //fp.log('parsedState', parsedState);

        //fp.log('toState', parsedState.state, parsedState.params);
        //fp.log(this.href(parsedState.state, parsedState.params));

        if(!this.initialized) _.empty(this.stateParams);

        var fromParams = $.extend({}, this.stateParams),
            toParams = $.extend({}, parsedState.params),
            changedParams = fpUtil.getUnique(fromParams, toParams),
            promises = [],
            scrollTo;

        if (!isDefaultPrevented) {
            var toState = parsedState.state,
                payload = {
                    toState: toState,
                    toParams: toParams,
                    fromState: this.current,
                    fromParams: fromParams,
                    toUrl: loc.href,
                    fromUrl: this.currentUrl,
                    changedParams: changedParams,
                    clientParams: {
                        scrollTo: undefined,
                        redirect: {
                            state: undefined,
                            stateParams: undefined
                        },
                        promises: []
                    }
                },
                clientParams = payload.clientParams;

            var event = fp.trigger(fp.events.ROUTE_BEFORE_CHANGE, payload),
                redirectToState = clientParams.redirect.state,
                redirectToStateParams = clientParams.redirect.stateParams;

            isDefaultPrevented = event.isDefaultPrevented();

            //if (!isDefaultPrevented && this.current != parsedState.state) {
            //    clientParams = $.extend({}, payloadClientParams);
            //
            //    payload = $.extend({}, payloadParams);
            //    payload.clientParams = clientParams;
            //
            //    isDefaultPrevented = event.isDefaultPrevented();
            //
            //    if (!redirectToState) {
            //        redirectToState = clientParams.redirect.state;
            //    }
            //    if (!redirectToStateParams) {
            //        redirectToStateParams = clientParams.redirect.stateParams;
            //    }
            //}

            if (isDefaultPrevented && !clientParams.disableRedirect) {
                var toUrl = redirectToState ? stateManager.href(redirectToState, redirectToStateParams) : this.currentUrl,
                    hash = '#' + S.getString(toUrl.split('#')[1]);

                if (redirectToState == this.current && window.history) window.history.back();
                else loc.replace(hash);

                return next(false);
            }

            scrollTo = clientParams.scrollTo;

            if(fp.loaded && fpUtil.isNull(scrollTo) && fp.Module.getViewModule()) {
                //BB #14104 (always scroll to top)
                scrollTo = !(fp.config.disableSmartScrollResults && !fp.device.xs);

                //var attrs = {rendered: true},
                //    module = fp.Module.get('page-title', {attrs: attrs}) /*|| fp.Module.get('department-breadcrumb', {attrs: attrs}) || fp.Module.getViewModule()*/;
                //
                //scrollTo = (module && module.$element) || true;
            }

            if (_.size(clientParams.promises)) {
                _.concat(promises, clientParams.promises);
            }
        }

        var redirect = routeManager.ensureRoute(parsedState.state, parsedState.params);
        if (redirect) return next(false);

        _.empty(this.stateParams);
        $.extend(this.stateParams, toParams);

        _.empty(routeManager.urlParams);
        $.extend(routeManager.urlParams, fpUtil.urlParams());

        _.empty(routeManager.searchParams);
        $.extend(routeManager.searchParams, fpUtil.urlParams({includeRouteSearch: false}));

        var historyItem = {
            name: parsedState.state.name || loc.pathname
        };
        //if(!parsedState.state.name) historyItem.pathname = loc.pathname;
        if (_.size(this.stateParams)) historyItem.stateParams = $.extend({}, this.stateParams);
        this.history.add(historyItem);

        if(this.initialized && _.size(changedParams)) {
            fp.productAdRenderId = _.now();
        }

        if(isDefaultPrevented) return next(false);

        this.from = this.current;
        this.current = parsedState.state;
        this.fromUrl = this.currentUrl;
        this.currentUrl = loc.href;
        this.fromParams = fromParams;
        this.toParams = toParams;
        this.changedParams = changedParams;

        //this.cachedState = getCurrentState();

        // fp.log('toState', this.current, toParams);

        isReloadTriggered = fpUtil.getBoolean(arguments.length > 1 ? arguments[arguments.length - 2] : false, false);

        if(this.current != this.from) {
            fpUi.blockUI();
        }

        //fp.log(this.current.ownParams, this.changedParams, _.hasAny(this.current.ownParams, this.changedParams));
        fpUtil.hideProgress($.when.apply($, promises))
            .always(function() {
                fpUi.unblockUI();
            });

        if (scrollTo) {
            var scrollToOptions;
            if(_.isObject(scrollTo) && !fpUtil.isJQuery(scrollTo)) {
                scrollToOptions = scrollTo.options;
                scrollTo = scrollTo.selector;
            }
            fpUtil.scrollTo(scrollTo, scrollToOptions);
        }

        //bug in router async mode, need to force on
        if(this._router) this._router.every.on();
    }

    //this is triggered on entering a route/state
    function onRouterOn() {
        var next = _.getFunction(arguments[arguments.length - 1], $.noop);

        $(document.body)
            .removeClass(this.from.data.cssClass)
            .addClass(this.current.data.cssClass);

        var payload = {
            toState: this.current,
            toParams: this.toParams,
            fromState: this.from,
            fromParams: this.fromParams,
            toUrl: this.currentUrl,
            fromUrl: this.fromUrl,
            changedParams: this.changedParams
        };

        if(this.current != this.from || isReloadTriggered) {
            fp.trigger(fp.events.STATE_CHANGED, $.extend({}, payload));
        }

        fp.trigger(fp.events.ROUTE_CHANGED, payload);

        //if(this.__promiseAnalyze && this.__promiseAnalyze.state() == 'pending') {
        //    this.__promiseAnalyze.deferred().reject('abort');
        //}

        next();
    }
    
    // function getCurrentState() {
    //     var state = null;
    //     try {
    //         state = window.history.state || null;
    //     } catch (e) {
    //         // MSIE can reportedly throw when there is no state (UNCONFIRMED).
    //     }
    //     return state;
    // }

    uiRouter.location = routerLocation;
    uiRouter.routeManager = routeManager;
    uiRouter.stateManager = stateManager;
})();